module.exports = __webpack_public_path__ + "img/add-doc.cda50a2d.svg";